import { NgOptimizedImage } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { User } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { retry } from 'rxjs';
import { UnifiedUserInfo } from 'src/app/domain';
import { AuthStateService } from 'src/app/services';
import { UserStore } from 'src/app/store';

@Component({
  selector: 'app-splash',
  template: `
    <div class="screen items-center justify-center">
      <img ngSrc="assets/icons/png/icon.png" width="512" height="512" priority alt="logo" />
    </div>
  `,
  standalone: true,
  imports: [NgOptimizedImage],
})
export class SplashComponent implements OnInit {
  private router: Router = inject(Router);
  private store = inject(UserStore);
  private authStateService = inject(AuthStateService);
  private destroyRef = inject(DestroyRef);

  ngOnInit() {
    this.authStateService.user$.pipe(retry(3), takeUntilDestroyed(this.destroyRef)).subscribe((user) => {
      if (user) {
        this.handleAuthenticatedUser(user);
      } else {
        this.router.navigate(['/auth/login']);
      }
    });
  }

  private handleAuthenticatedUser(user: User) {
    this.store.loadEntity({
      id: user.uid,
      callback: (entity) => {
        if (entity) {
          this.handleSignUpStatus(entity, this.router);
        } else {
          console.log('No user entity found in store');
          this.router.navigate(['/auth/login']);
        }
      },
    });
  }

  private handleSignUpStatus(user: UnifiedUserInfo, router: Router): void {
    let queryParams = { email: user.email };
    switch (user.signUpStatus) {
      case 'Completed':
        this.router.navigate(['home'], {
          queryParams: {
            redirect: 'splash',
          },
        });
        break;
      case 'VerifyAccount':
        router.navigate(['/auth/verify-otp'], { queryParams });
        break;
      case 'Referral':
        router.navigate(['/auth/referral-code'], { queryParams });
        break;
      case 'SetPin':
        queryParams = { ...queryParams, referralCode: user.referral } as { email: any; referralCode: any };
        router.navigate(['/auth/set-pin'], { queryParams });
        break;
      case 'SetEmergencyPin':
        router.navigate(['/auth/set-second-pin'], { queryParams });
        break;
      default:
        console.log('Unknown sign up status:', user.signUpStatus);
        router.navigate(['/auth/login']);
        break;
    }
  }
}
